// extracted by mini-css-extract-plugin
module.exports = {"order-skeletons":"dWnJPK3jS6ua5bszT4WrW","order-item":"_3MmsvHiqqyi6O-2oYK75GJ","skeletons":"_11jsuRT0PlfSG5oKJSLmIr","loading":"_3SmYFxBzcFR7jl5P2alPnF"};